import { Component, Input } from "@angular/core";
import { NotificationBulkTriggerDto } from "../../../service/dto";

@Component({
	selector: 'app-schedule-info',
	standalone: false,
	templateUrl: './schedule-info.component.html',
	styleUrl: './schedule-info.component.scss'
})
export class ScheduleInfoComponent {
	@Input() trigger?: NotificationBulkTriggerDto;

}